/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEnableHotelGroups, selectHotelName } from 'modules/dashboard/selectors';
import { REPORT_TYPE } from 'modules/dashboard/constants';
import {
  selectEnableSecondaryHotelGroups,
  selectIsPrimary,
  selectHotelFocusOn,
} from '../selectors';
import { paceActions } from '../slice';
// Custom hook to determine the displayed visual type based on hotel selection and date comparison
const UseVisualSwap = () => {
  const dispatch = useDispatch();
  const hotelFocusOn = useSelector(selectHotelFocusOn);
  const selectedHotel = useSelector(selectHotelName);
  const enableHotelGroups = useSelector(selectEnableHotelGroups);
  const enableSecondaryHotelGroups = useSelector(selectEnableSecondaryHotelGroups);
  const isPrimary = useSelector(selectIsPrimary);
  /**
   * Different hotels/ hotel groups selected in primary and secondary dropdowns -> Display Pace Hotel visuals
   * Same hotel/ hotel group selected in primary and secondary dropdowns AND  'PRIMARY' option selected on date comparison -> Display Pace Segment visuals
   * Else -> Display Pace Time visuals
   */
  useEffect(() => {
    if (isPrimary) {
      dispatch(paceActions.setActiveTab(REPORT_TYPE.PACE_SEGMENT_WIDGET));
    } else if (hotelFocusOn?.id !== selectedHotel?.id) {
      dispatch(paceActions.setActiveTab(REPORT_TYPE.PACE_HOTEL_WIDGET));
    } else {
      dispatch(paceActions.setActiveTab(REPORT_TYPE.PACE_TIME_WIDGET));
    }
  }, [hotelFocusOn, selectedHotel, enableHotelGroups, enableSecondaryHotelGroups, isPrimary]);
};
//
export default UseVisualSwap;
